import { GridBoxType } from 'types';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';

interface GridBoxProps {
  gridBoxData?: any;
}

export default function GridBox({ gridBoxData }: GridBoxProps) {
  return (
    <div>
      {gridBoxData && gridBoxData.length >= 1 && (
        <div className="grid mx-auto my-8">
          {gridBoxData.map((GridBoxItem: GridBoxType) => (
            <div className="col-12 lg:col-6 xl:col-4 mx-auto flex">
              {GridBoxItem.boxLink?.includes('http') ? (
                <a
                  href={GridBoxItem.boxLink}
                  target="_blank"
                  rel="noreferrer"
                  className="hover-reveal-box interact-card no-underline animate-col-width mx-auto w-11">
                  {!!GridBoxItem?.boxImage && (
                    <img
                      src={GridBoxItem?.boxImage.url}
                      alt={GridBoxItem?.boxTitle}
                      className="block mb-0 w-full mx-auto"
                    />
                  )}
                  {!!GridBoxItem?.boxTitle && (
                    <h5 className="font-bold my-1 py-2 text-center">
                      {GridBoxItem?.boxTitle}
                    </h5>
                  )}
                  {!!GridBoxItem?.boxDescription && (
                    <div className="hover-reveal-content">
                      {parse(GridBoxItem?.boxDescription.html)}
                    </div>
                  )}
                </a>
              ) : (
                <Link
                  to={GridBoxItem.boxLink || '#'}
                  className="hover-reveal-box interact-card no-underline animate-col-width mx-auto w-11">
                  {!!GridBoxItem?.boxImage && (
                    <img
                      src={GridBoxItem?.boxImage.url}
                      alt={GridBoxItem?.boxTitle}
                      className="block mb-0 w-full mx-auto"
                    />
                  )}
                  {!!GridBoxItem?.boxTitle && (
                    <h5 className="font-bold my-1 py-2 text-center">
                      {GridBoxItem?.boxTitle}
                    </h5>
                  )}
                  {!!GridBoxItem?.boxDescription && (
                    <div className="hover-reveal-content">
                      {parse(GridBoxItem?.boxDescription.html)}
                    </div>
                  )}
                </Link>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
